<template>
  <div>
    <v-btn-toggle
      mandatory
      style="width: 100%"
    >
      <v-btn
        large
        v-for="(item, i) in items"
        :key="`${item.type}--${i}`"
        @click="setSelectTypeBet(item.type)"
        style="flex: 1"
      >
        <v-icon left :color="handleColorType(item.type)" size="10"
          >mdi-circle</v-icon
        >
        {{ item.text }}
      </v-btn>
    </v-btn-toggle>
  </div>
</template>
<script>
export default {
  name: "components-common-filters-select-type",
  data: () => ({
    select: {},
  }),
  computed: {
    items() {
        return [
          { text: this.$t('deposit'), type: 'deposit' },
          { text: this.$t('bonus'), type: 'bonus' },
        ];
    },
  },
  methods: {
    setSelectTypeBet(type) {
      this.$store.commit("setSelectTypeBet", type);
    },
    handleColorType(type) {
      switch (type) {
        case 'bonus':
          return 'purple';
        case 'deposit':
          return 'green';  
      }
    }
  },
};
</script>
